import React from 'react';
import ButtonDelete from './ButtonDelete';
import { Button, ButtonGroup, Table } from 'reactstrap';
import { formattedDate, getLimitedText } from '../helpers/GenericHelpers';

export default class ProjectList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      projects: this.props.projects || [],
    };
  }

  render() {
    return (<Table striped responsive hover>
      <thead>
        <tr>
          <th>Project Code</th>
          <th>Title</th>
          {this.props.skipOwner ? null : <th>User</th>}
          <th>Last Modified</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {this.state.projects.map((project, index) =>
          (<tr key={index}>
            <td>
              <a
                data-turbolinks={false}
                href={`/wfdw/projects/${project.id}`}
              >
                {getLimitedText(project.code)}
              </a>
            </td>
            <td>{getLimitedText(project.title)}</td>
            {this.props.skipOwner ? null : <td>{getLimitedText(project.owner)}</td>}
            <td>{formattedDate(project.updated_at)}</td>
            <td>
              <ButtonGroup size="sm">
                <Button
                  href={`/get/archive/${project.id}`}
                  title={`Download ${project.code}`}
                  data-turbolinks={false}
                  color="secondary"
                >
                  <i className="fa fa-download" />
                </Button>
                <ButtonDelete
                  key={`${project.code}-del`}
                  title={`Delete ${project.code}`}
                  action={() => this.props.removeProject(project.id)}
                />
              </ButtonGroup>
            </td>
          </tr>),
        )}
      </tbody>
    </Table>);
  }
}
